import template from './passengers-seats.html';

const DIRECTIVE_NAME = PassengersSeats.DIRECTIVE_NAME = 'ktPassengersSeats';

export default function PassengersSeats() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: PassengersSeatsController,
        controllerAs: '$ctrl',
        scope: {
            travellers: `=${DIRECTIVE_NAME}`,
            tripDetails: `=${DIRECTIVE_NAME}TripDetails`,
            selectedSeats: `=${DIRECTIVE_NAME}SelectedSeats`,
            flight: `=${DIRECTIVE_NAME}Flight`,
            onTravellerChange: `=${DIRECTIVE_NAME}OnTravellerChange`,
            preSelectedTraveller: `=?${DIRECTIVE_NAME}PreSelectedTraveller`,
            map: `=?${DIRECTIVE_NAME}Map`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => {
            $ctrl.$onInit();
        },
    };
}

export function PassengersSeatsController() {
    const vm = this;

    Object.assign(vm, {
        $onInit,
        selectTraveller,
    });

    function $onInit() {
        if (vm.travellers.length && vm.preSelectedTraveller) {
            selectTraveller(vm.preSelectedTraveller);
        }
    }

    function selectTraveller(traveller) {
        vm.selected = traveller;
        vm.onTravellerChange(traveller);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/passengers-seats/passengers-seats-component.js